var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBars = props => {
  props = {
    ...props,
    style: {
      display: 'inline-block',
      width: '1em',
      height: '1em',
      maxWidth: '100%',
      maxHeight: '100%',
      fill: 'currentColor',
      transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      flexShrink: 0,
      ...props.style
    }
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.623 8.781c.192 0 .373-.032.544-.096.171-.064.32-.16.449-.287.128-.15.224-.304.288-.464.064-.16.096-.346.096-.56 0-.191-.032-.372-.096-.543a1.242 1.242 0 0 0-.737-.735A1.54 1.54 0 0 0 30.623 6H1.377a1.54 1.54 0 0 0-.544.096 1.245 1.245 0 0 0-.737.735c-.064.17-.096.352-.096.544 0 .213.032.4.096.56.064.159.16.314.288.463.129.128.278.223.449.287.17.064.352.096.544.096h29.246Zm0 8.75c.192 0 .373-.032.544-.096a1.245 1.245 0 0 0 .737-.736c.064-.17.096-.351.096-.543 0-.192-.032-.373-.096-.543a1.242 1.242 0 0 0-.737-.736 1.54 1.54 0 0 0-.544-.096H1.377a1.54 1.54 0 0 0-.544.096 1.245 1.245 0 0 0-.737.736c-.064.17-.096.351-.096.543 0 .192.032.373.096.543a1.242 1.242 0 0 0 .737.736c.17.064.352.096.544.096h29.246Zm0 8.781c.192 0 .373-.032.544-.096.171-.064.32-.16.449-.288.128-.149.224-.303.288-.463.064-.16.096-.347.096-.56 0-.191-.032-.373-.096-.543a1.242 1.242 0 0 0-.737-.735 1.54 1.54 0 0 0-.544-.096H1.377a1.54 1.54 0 0 0-.544.096 1.245 1.245 0 0 0-.737.735c-.064.17-.096.352-.096.543 0 .213.032.4.096.56.064.16.16.314.288.463.129.128.278.224.449.288.17.064.352.096.544.096h29.246Z"
  })));
};
export default SvgBars;